export {
    StudentActivityCongratsPage,
    type ActivityCongratsNext,
    type StudentActivityCongratsPageProps,
} from "./StudentActivityCongratsPage"
